<ng-container bbTransactionSigningErrorCustomizable [bbHostRef]="hostRef"></ng-container>

<ng-template bbTransactionSigningErrorCustomizable let-hostRef>
  <div class="bb-block bb-block--md" data-role="ts-error">
    <div class="bb-block bb-block--md">
      <ng-container *ngTemplateOutlet="tsErrorState"></ng-container>
    </div>
    <div class="bb-button-bar bb-button-bar--center">
      <button bbButton
        data-role="ts-accept-error"
        class="bb-button-bar__button"
        color="primary"
        i18n="Cancel transaction button@@bb-transaction-signing-error.cancel"
        (click)="hostRef.onClose()">
        Close
      </button>
    </div>
  </div>

  <ng-template #tsErrorState>
    <ng-container [ngSwitch]="hostRef.error?.errorDescription">
      <bb-empty-state-ui *ngSwitchCase="'invalid_token'"
        iconSize="xxl"
        iconModifier="lock"
        i18n-title="Transaction signing invalid token title@@bb-transaction-signing-error.invalid-token.title"
        title="Access denied"
        i18n-subtitle="Transaction signing invalid token subtitle@@bb-transaction-signing-error.invalid-token.subtitle"
        subtitle="We were unable to process this transaction. Please cancel this dialogue and try again.">
      </bb-empty-state-ui>
      <bb-empty-state-ui *ngSwitchCase="'confirmation_not_found'"
        iconSize="xxl"
        iconModifier="error-outline"
        i18n-title="Transaction signing not found title@@bb-transaction-signing-error.not-found.title"
        title="No confirmation found"
        i18n-subtitle="Transaction signing not found subtitle@@bb-transaction-signing-error.not-found.subtitle"
        subtitle="We were unable to process this transaction. Please cancel this dialogue and try again.">
      </bb-empty-state-ui>
      <bb-empty-state-ui *ngSwitchCase="'confirmation_is_not_pending'"
        iconSize="xxl"
        iconModifier="access-alarm"
        i18n-title="Transaction signing not pending title@@bb-transaction-signing-error.not-pending.title"
        title="The confirmation has expired"
        i18n-subtitle="Transaction signing not pending subtitle@@bb-transaction-signing-error.not-pending.subtitle"
        subtitle="This transaction has timed out and been cancelled. Please cancel this dialogue and try again.">
      </bb-empty-state-ui>
      <bb-empty-state-ui *ngSwitchCase="'confirmation_user_mismatch'"
        iconSize="xxl"
        iconModifier="error-outline"
        i18n-title="Transaction signing user mismatch title@@bb-transaction-signing-error.user-mismatch.title"
        title="Something went wrong"
        i18n-subtitle="Transaction signing user mismatch subtitle@@bb-transaction-signing-error.user-mismatch.subtitle"
        subtitle="You do not have permission to confirm this action. Please cancel this dialogue and try again.">
      </bb-empty-state-ui>
      <bb-empty-state-ui *ngSwitchCase="'rejected_by_user'"
        iconSize="xxl"
        iconModifier="error-outline"
        i18n-title="Transaction signing rejected title@@bb-transaction-signing-error.rejected.title"
        title="Transaction rejected by user"
        i18n-subtitle="Transaction signing rejected subtitle@@bb-transaction-signing-error.rejected.subtitle"
        subtitle="We were unable to process this transaction. Please cancel this dialogue and try again.">
      </bb-empty-state-ui>
      <bb-empty-state-ui *ngSwitchCase="'user_disabled'"
        iconSize="xxl"
        iconModifier="lock"
        i18n-title="Transaction signing disabled title@@bb-transaction-signing-error.disabled.title"
        title="Unable to process transaction"
        i18n-subtitle="Transaction signing disabled subtitle@@bb-transaction-signing-error.disabled.subtitle"
        subtitle="This user is currently locked. Please cancel the dialogue and unlock your account before retrying the action.">
      </bb-empty-state-ui>
      <bb-empty-state-ui *ngSwitchCase="'user_temporarily_disabled'"
        iconSize="xxl"
        iconModifier="lock"
        i18n-title="Transaction signing temporarily disabled title@@bb-transaction-signing-error.temporarily-disabled.title"
        title="Unable to process transaction"
        i18n-subtitle="Transaction signing temporarily disabled subtitle@@bb-transaction-signing-error.temporarily-disabled.subtitle"
        subtitle="This user is currently locked. Please cancel the dialogue and unlock your account before retrying the action.">
      </bb-empty-state-ui>
      <bb-empty-state-ui *ngSwitchCase="'unsupported_challenge'"
        iconSize="xxl"
        iconModifier="error-outline"
        i18n-title="Transaction signing unsupported challenge title@@bb-transaction-signing-error.unsupported-challenge.title"
        title="Unable to process request"
        i18n-subtitle="Transaction signing unsupported challenge subtitle@@bb-transaction-signing-error.unsupported-challenge.subtitle"
        subtitle="The transaction requires an unsupported challenge. Please cancel this dialogue and contact an admin.">
      </bb-empty-state-ui>
      <bb-empty-state-ui *ngSwitchCase="'challenge_not_found'"
        iconSize="xxl"
        iconModifier="error-outline"
        i18n-title="Transaction signing challenge not found title@@bb-transaction-signing-error.challenge-not-found.title"
        title="Something went wrong"
        i18n-subtitle="Transaction signing challenge not found subtitle@@bb-transaction-signing-error.challenge-not-found.subtitle"
        subtitle="We were unable to process this transaction. Please cancel this dialogue and try again.">
      </bb-empty-state-ui>
      <bb-empty-state-ui *ngSwitchCase="'hard_token_integration_error'"
        iconSize="xxl"
        iconModifier="error-outline"
        i18n-title="Transaction signing hard token integration title@@bb-transaction-signing-error.hard-token-integration.title"
        title="Something went wrong"
        i18n-subtitle="Transaction signing hard token integration subtitle@@bb-transaction-signing-error.hard-token-integration.subtitle"
        subtitle="We could not reach the hard-token vendor to confirm your response. Please cancel this dialogue and try again.">
      </bb-empty-state-ui>
      <bb-empty-state-ui *ngSwitchCase="'no_devices_registered'"
        iconSize="xxl"
        iconModifier="phonelink-off"
        i18n-title="Transaction signing no devices registered title@@bb-transaction-signing-error.no-devices-registered.title"
        title="No devices available"
        i18n-subtitle="Transaction signing no devices registered subtitle@@bb-transaction-signing-error.no-devices-registered.subtitle"
        subtitle="We were unable to process this transaction as no devices are registered. Please cancel this dialogue and try again.">
      </bb-empty-state-ui>
      <bb-empty-state-ui *ngSwitchDefault
        iconSize="xxl"
        iconModifier="error-outline"
        i18n-title="Transaction signing default error title@@bb-transaction-signing-error.default.title"
        title="Something went wrong"
        i18n-subtitle="Transaction signing default error subtitle@@bb-transaction-signing-error.default.subtitle"
        subtitle="We have experienced a critical error on this transaction. Please cancel this dialogue and try again.">
      </bb-empty-state-ui>
    </ng-container>
  </ng-template>
</ng-template>
